import angular from 'angular';
import uiRouter from 'angular-ui-router';
import OauthComponent from './oauth.component';
import routing from './oauth.routes';

export default angular
  .module('verifyApp.oauth', [uiRouter])
  .config(routing)
  .component('oauth', OauthComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/oauth/index.js